/*
|--------------------------------------------------------------------------
| CARD VARIANT QUICK ADD
|--------------------------------------------------------------------------
| Loaded once from layout/theme.liquid.
| Uses one click listener on the document, so it also works for product
| cards inserted later (product recommendations, infinite scroll, filters).
*/

(function () {

  // Stop the file running twice if it ever gets included twice
  if (window.cardQuickAddInitialized) return;
  window.cardQuickAddInitialized = true;

  // Sections Shopify sends back with every cart request
  const CART_SECTIONS = 'cart-drawer,cart-icon-bubble';

  let openedQuickAdd = null;

  /*
  |--------------------------------------------------------------------------
  | CART REQUEST
  |--------------------------------------------------------------------------
  | One request does the cart change AND returns the updated drawer HTML,
  | so there's no second fetch to refresh the drawer.
  */
  async function cartRequest(url, body) {

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        ...body,
        sections: CART_SECTIONS,
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Cart request failed');
    }

    return data;
  }

  /*
  |--------------------------------------------------------------------------
  | UPDATE DRAWER + BUBBLE, THEN OPEN DRAWER
  |--------------------------------------------------------------------------
  */
  function renderCart(sections) {

    if (!sections) return;

    const parse = html => new DOMParser().parseFromString(html, 'text/html');

    // Cart drawer
    const newDrawer = sections['cart-drawer']
      && parse(sections['cart-drawer']).querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.replaceWith(newDrawer);
    }

    // Cart bubble
    const newBubble = sections['cart-icon-bubble']
      && parse(sections['cart-icon-bubble']).querySelector('#cart-icon-bubble');
    const currentBubble = document.querySelector('#cart-icon-bubble');

    if (newBubble && currentBubble) {
      currentBubble.innerHTML = newBubble.innerHTML;
    }

    // Open drawer. Wait two frames so the new drawer is drawn closed
    // first, otherwise it appears instantly instead of sliding in.
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => cartDrawer.open());
      });
    }
  }

  /*
  |--------------------------------------------------------------------------
  | SYNC COUNTERS WITH THE REAL CART
  |--------------------------------------------------------------------------
  */
  async function syncCounters(container) {

    try {

      const cart = await fetch('/cart.js').then(res => res.json());

      // Total quantity per variant
      const qtyByVariant = {};

      for (const item of cart.items) {
        qtyByVariant[item.variant_id] =
          (qtyByVariant[item.variant_id] || 0) + item.quantity;
      }

      container.querySelectorAll('.variant-qty[data-qty]').forEach(el => {
        el.textContent = qtyByVariant[el.dataset.qty] || 0;
      });

    } catch (error) {

      console.error('Counter sync failed:', error);

    }
  }

  /*
  |--------------------------------------------------------------------------
  | PLUS / MINUS
  |--------------------------------------------------------------------------
  | delta = 1 for plus, -1 for minus
  */
  async function changeQty(btn, delta) {

    const row = btn.closest('.card-variant-row');

    // Ignore clicks while this row already has a request running
    if (row.classList.contains('is-busy')) return;

    const variantId = Number(btn.dataset.variantId);
    const qtyEl = row.querySelector('.variant-qty');
    const currentQty = parseInt(qtyEl.textContent, 10) || 0;

    // Nothing to remove
    if (delta < 0 && currentQty <= 0) return;

    row.classList.add('is-busy');
    btn.classList.add('loading');

    try {

      let data;

      if (delta > 0) {

        data = await cartRequest('/cart/add.js', {
          id: variantId,
          quantity: delta
        });

        // add.js returns the line item with its new total quantity
        qtyEl.textContent = data.quantity ?? currentQty + delta;


        } else {

        // Find the real cart line for this variant
        const cart = await fetch('/cart.js').then(res => res.json());
        const line = cart.items.find(item => item.variant_id === variantId);

        if (!line) {
            qtyEl.textContent = 0;
            return;
        }

        // Change it by its line key, which Shopify always accepts
        data = await cartRequest('/cart/change.js', {
            id: line.key,
            quantity: line.quantity - 1
        });

        // Show the total left for this variant
        const remaining = data.items
            .filter(item => item.variant_id === variantId)
            .reduce((sum, item) => sum + item.quantity, 0);

        qtyEl.textContent = remaining;

        }

      renderCart(data.sections);

    } catch (error) {

      console.error(error);

      // Something was out of date (e.g. cart changed in another tab),
      // so re-read the real quantities for this row
      syncCounters(row);

    } finally {

      btn.classList.remove('loading');
      row.classList.remove('is-busy');

    }
  }

  /*
  |--------------------------------------------------------------------------
  | GLOBAL CLICK HANDLER
  |--------------------------------------------------------------------------
  */
  document.addEventListener('click', function (e) {

    // Open / close variant panel
    const trigger = e.target.closest('.card-quickadd-trigger');

    if (trigger) {

      e.preventDefault();
      e.stopPropagation();

      const wrapper = trigger.closest('.card-variant-quickadd');

      if (wrapper.classList.contains('active')) {

        wrapper.classList.remove('active');
        openedQuickAdd = null;

      } else {

        if (openedQuickAdd) openedQuickAdd.classList.remove('active');

        wrapper.classList.add('active');
        openedQuickAdd = wrapper;
        syncCounters(wrapper);

      }

      return;
    }

    // Plus / minus
    const qtyBtn = e.target.closest('.qty-btn');

    if (qtyBtn) {
      e.preventDefault();
      e.stopPropagation();
      changeQty(qtyBtn, qtyBtn.classList.contains('plus') ? 1 : -1);
      return;
    }

    // Click outside closes the panel
    if (openedQuickAdd && !e.target.closest('.card-variant-quickadd')) {
      openedQuickAdd.classList.remove('active');
      openedQuickAdd = null;
    }

  });

})();